import { countSearches } from '../queries/countSearches'

export const totalSearchesGauge = {
  id: 'total_search',
  queries: [countSearches],
  title: 'Most searched terms',
}
